import axiosInstance from "../../api/axiosInstance";

export const fetchSocialMediaAPI = async () => {
  const res = await axiosInstance.get("socialMedia/get-all-social-media");
  return res.data;
};

export const createSocialMediaAPI = async (payload) => {
  const res = await axiosInstance.post(
    "socialMedia/create-social-media",
    payload
  );
  return res.data;
};

export const updateSocialMediaAPI = async ({ name, ...data }) => {
  const res = await axiosInstance.put("socialMedia/update-social-media", {
    name,
    ...data,
  });
  return res.data;
};

export const deleteSocialMediaAPI = async (name) => {
  const res = await axiosInstance.delete("socialMedia/delete-social-media", {
    data: { name },
  });
  return res.data;
};
